import { formatCountdown, parseCountdownDate, startCountdown } from '@lyle/countdown';

class LylePromoBanner extends HTMLElement {
  #stopCountdowns = [];

  connectedCallback() {
    this.#initCountdowns();
  }

  disconnectedCallback() {
    for (const stop of this.#stopCountdowns) {
      stop();
    }

    this.#stopCountdowns = [];
  }

  #initCountdowns() {
    const containers = this.querySelectorAll('[data-promo-banner-countdown-container]');

    for (const container of containers) {
      this.#bindCountdown(container);
    }
  }

  #bindCountdown(container) {
    const countdown = container.querySelector('[data-promo-banner-countdown]');
    if (!countdown) return;

    const endDate = parseCountdownDate(container.dataset.countdown);
    if (!endDate) return;

    const stop = startCountdown(
      endDate,
      (timeLeft) => {
        container.dataset.countdownState = 'running';
        countdown.textContent = formatCountdown(timeLeft);
      },
      () => {
        container.dataset.countdownState = 'ended';
        countdown.textContent = '';
      },
    );

    this.#stopCountdowns.push(stop);
  }
}

if (!customElements.get('lyle-promo-banner')) {
  customElements.define('lyle-promo-banner', LylePromoBanner);
}
